<template>
	<div id="buildContent" ref="buildContent" class="form-builder__content">
		<ActionBar />
		<div class="form-builder__scroll small-scroll-container scrollbar scrollbar--wide">
			<div id="c-forms-builder">
				<div class="c-forms-main">
					<div id="c-forms-settings" class="c-forms-settings scrollbar">
						<div class="c-forms-settings-indicator"></div>
						<FormSettings />
						<PaymentSettings />
						<FieldSettings />
						<WorkflowSettings />
					</div>
					<Canvas />
				</div>
				<CanvasSettingsWorkflow />
				<CanvasSettingsPayment />
			</div>
			<SaveErrorBanner />
			<CopyConfirmationDialog />
			<FeatureAvailabilityWarningDialog />
			<SecurityAlertDialog />
			<EditNotificationDialog />
			<EditEmailDialog />
			<EditTrackingPixelDialog />
			<RangeFieldEditorTemplate />
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import ActionBar from './ActionBar.vue';
	import FormSettings from './FormSettings.vue';
	import PaymentSettings from './PaymentSettings.vue';
	import FieldSettings from './FieldSettings.vue';
	import WorkflowSettings from './WorkflowSettings.vue';
	import Canvas from './Canvas.vue';
	import CanvasSettingsWorkflow from './CanvasSettingsWorkflow.vue';
	import CanvasSettingsPayment from './CanvasSettingsPayment.vue';
	import SaveErrorBanner from './SaveErrorBanner.vue';
	import CopyConfirmationDialog from './CopyConfirmationDialog.vue';
	import FeatureAvailabilityWarningDialog from './FeatureAvailabilityWarningDialog.vue';
	import SecurityAlertDialog from './SecurityAlertDialog.vue';
	import EditNotificationDialog from './EditNotificationDialog.vue';
	import EditEmailDialog from './EditEmailDialog.vue';
	import EditTrackingPixelDialog from './EditTrackingPixelDialog.vue';
	import RangeFieldEditorTemplate from './RangeFieldEditorTemplate.vue';

	export default defineComponent({
		components: {
			ActionBar,
			FormSettings,
			PaymentSettings,
			FieldSettings,
			WorkflowSettings,
			Canvas,
			CanvasSettingsWorkflow,
			CanvasSettingsPayment,
			SaveErrorBanner,
			CopyConfirmationDialog,
			FeatureAvailabilityWarningDialog,
			SecurityAlertDialog,
			EditNotificationDialog,
			EditEmailDialog,
			EditTrackingPixelDialog,
			RangeFieldEditorTemplate
		}
	});
</script>
